import { combineReducers } from "redux";
import app from './reducers/app'
import board from './reducers/board'
import eth from './reducers/eth'

export default combineReducers({ app, board, eth });